export function processingOrgCsv(args) {
  const { progress_path, review_path, completed_path } = args;

  return {
    progressPayload: null,
    progress: 0,
    polling: false,
    intervalId: null,
    pollCount: 0,
    maxPolls: 150, // 5 minutes worth of polling at 2-second intervals

    init() {
      // Start polling immediately
      this.startProgressPolling();
    },

    startProgressPolling() {
      this.polling = true;

      // Poll immediately, then every 2 seconds
      this.pollProgress();
      this.intervalId = setInterval(() => {
        if (this.polling) {
          this.pollProgress();
        }
      }, 2000);
    },

    async pollProgress() {
      try {
        this.pollCount++;

        // Stop polling if we've been trying too long
        if (this.pollCount > this.maxPolls) {
          console.log("Max polling attempts reached, stopping");
          this.polling = false;
          if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
          }
          return;
        }

        const response = await fetch(progress_path);

        if (response.ok) {
          const data = await response.json();
          this.progressPayload = data;

          // Calculate progress percentage
          if (data.total_items > 0) {
            this.progress = Math.min(
              (data.items_processed / data.total_items) * 100,
              100,
            );
          } else {
            this.progress = 0;
          }

          // If job is complete, redirect based on staging status
          if (data.completion_report) {
            this.polling = false;
            if (this.intervalId) {
              clearInterval(this.intervalId);
              this.intervalId = null;
            }

            // Wait a moment to show success message, then redirect
            setTimeout(() => {
              // If staged is true, redirect to review; if staged is false and completed, redirect to completed page
              const redirectUrl = data.staged ? review_path : completed_path;

              window.location.href = redirectUrl;
            }, 2000);
          }

          // If job failed, stop polling but don't redirect
          if (data.failed_at) {
            console.log("Job failed");
            this.polling = false;
            if (this.intervalId) {
              clearInterval(this.intervalId);
              this.intervalId = null;
            }
          }
        } else {
          console.error(
            "Progress polling failed with status:",
            response.status,
          );
        }
      } catch (error) {
        console.error("Error polling progress:", error);
        // Continue polling despite errors, in case it's a temporary network issue
      }
    },
  };
}
